import { render, staticRenderFns } from "./telegramChat.vue?vue&type=template&id=75b89098&scoped=true"
import script from "./telegramChat.vue?vue&type=script&lang=js"
export * from "./telegramChat.vue?vue&type=script&lang=js"
import style0 from "./telegramChat.vue?vue&type=style&index=0&id=75b89098&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b89098",
  null
  
)

export default component.exports